import AppProvider from "providers/AppProvider";

const App = () => <AppProvider />;

export default App;
